<mat-radio-group *ngIf="!multiple"
                 class="options"
                 [disabled]="true">
  <div *ngFor="let option of options"
       class="option"
       [class.selected]="isSelected(option)"
       [class.correct]="option.isCorrect && isSelected(option)"
       [class.shouldSelect]="option.isCorrect && !isSelected(option)"
       [class.wrong]="(option.isCorrect !== isSelected(option)) && !(option.isCorrect && !isSelected(option)) && testType !== 'POLL'">
    <div class="icon">
      <mat-icon *ngIf="option.isCorrect && isSelected(option)">check</mat-icon>
      <mat-icon *ngIf="option.isCorrect && !isSelected(option)">priority_high</mat-icon>
      <mat-icon *ngIf="(option.isCorrect !== isSelected(option)) && !(option.isCorrect && !isSelected(option)) && testType !== 'POLL'">close
      </mat-icon>
    </div>
    <mat-radio-button [value]="option.id.toString()"
                      [checked]="isSelected(option)"></mat-radio-button>
    <div class="text">{{option.text}}</div>
  </div>
</mat-radio-group>

<section *ngIf="multiple"
         class="options">
  <div *ngFor="let option of options"
       class="option"
       [class.selected]="isSelected(option)"
       [class.correct]="option.isCorrect && isSelected(option)"
       [class.shouldSelect]="option.isCorrect && !isSelected(option)"
       [class.wrong]="(option.isCorrect !== isSelected(option)) && !(option.isCorrect && !isSelected(option)) && testType !== 'POLL'">
    <div class="icon">
      <mat-icon *ngIf="option.isCorrect && isSelected(option)">check</mat-icon>
      <mat-icon *ngIf="option.isCorrect && !isSelected(option)">priority_high</mat-icon>
      <mat-icon *ngIf="(option.isCorrect !== isSelected(option)) && !(option.isCorrect && !isSelected(option)) && testType !== 'POLL'">close
      </mat-icon>
    </div>
    <mat-checkbox [value]="option.id.toString()"
                  [checked]="isSelected(option)"
                  [disabled]="true"></mat-checkbox>
    <div class="text checkbox">{{option.text}}</div>
  </div>
</section>
